export default {
  '17': {
    id: 17,
    name: 'iso',
    path: 'iso27001',
    humanName: 'ISO 27001',
    frameworkTitle: 'ISO 27001',
    manageFrameworksName: 'ISO 27001',
    color: '#24d6a3',
    fill_color: '#24d6a3',
    description: '',
    flat: true,
    parse: true,
    layout: 1,
    enabled:null
  },
  '2': {
    id: 2,
    name: 'pci',
    path: 'pci-dss',
    humanName: 'PCI-DSS',
    frameworkTitle: 'PCI-DSS',
    manageFrameworksName: 'PCI-DSS',
    color: '#f24b59',
    fill_color: '#f24b59',
    description: '',
    flat: false,
    parse: true,
    layout: 1,
    enabled:null
  },
  '3': {
    id: 3,
    name: 'hipaa',
    path: 'hipaa',
    humanName: 'HIPAA Detailed',
    frameworkTitle: 'HIPAA Detailed',
    manageFrameworksName: 'HIPAA Detailed',
    color: '#f2a71a',
    fill_color: '#f2a71a',
    description: 'Manage, track, and link evidence to the HIPAA Compliance Rules',
    flat: false,
    parse: false,
    layout: 1,
    enabled:null
  },
  /*'4': {
    id: 4,
    name: 'nist',
    path: 'nist',
    humanName: 'NIST 800-53',
    frameworkTitle: 'NIST 800-53',
    manageFrameworksName: 'NIST 800-53',
    color: '#0f3d59',
    fill_color: '#0f3d59',
    description: '',
    flat: true,
    parse: false,
    layout: 1,
    enabled:null
  },*/
  '5': {
    id: 5,
    name: 'gdpr',
    path: 'gdpr',
    humanName: 'GDPR',
    frameworkTitle: 'GDPR',
    manageFrameworksName: 'GDPR',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: '',
    flat: true,
    parse: true,
    layout: 1,
    enabled:null
  },
  '6': {
    id: 6,
    name: 'sans',
    path: 'sans-top-20',
    humanName: 'SANS TOP 20',
    frameworkTitle: 'SANS TOP 20',
    manageFrameworksName: 'SANS TOP 20',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: `A prioritized set of actions to protect your organization and data from known cyber attack vendors`,
    flat: false,
    parse: false,
    layout: 1,
    enabled:null
  },
  '7': {
    id: 7,
    name: 'hipaa-lite',
    path: 'hipaa-lite',
    humanName: 'HIPAA',
    frameworkTitle: 'HIPAA',
    manageFrameworksName: 'HIPAA',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: `Manage, track, and link evidence to the HIPAA Compliance Rules`,
    flat: false,
    parse: false,
    layout: 2,
    enabled:null
  },
  '8': {
    id: 8,
    name: 'hipaaawarenessquiz',
    path: 'hipaaawarenessquiz',
    humanName: 'HIPAA Awareness Quiz',
    frameworkTitle: 'HIPAA Awareness Quiz',
    manageFrameworksName: 'HIPAA Awareness Quiz',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: false,
    parse: false,
    layout: 2,
    enabled:null
  },
  '9': {
    id: 9,
    name: 'securityquiz',
    path: 'securityawareness',
    humanName: 'Security Awareness Quiz',
    frameworkTitle: 'Security Awareness Quiz',
    manageFrameworksName: 'Security Awareness Quiz',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: false,
    parse: false,
    layout: 1,
    enabled:null
  },
  '10': {
    id: 10,
    name: 'cmmc1',
    path: 'cmmc1',
    humanName: 'CMMC',
    frameworkTitle: 'CMMC Level 1',
    manageFrameworksName: 'CMMC Level 1',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: false,
    parse: false,
    layout: 1,
    levels: true,
    enabled:null
  },
  '11': {
    id: 11,
    name: 'cmmc2',
    path: 'cmmc2',
    humanName: 'CMMC',
    frameworkTitle: 'CMMC Level 2',
    manageFrameworksName: 'CMMC Level 2',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: false,
    parse: false,
    layout: 1,
    levels: true,
    enabled:null
  },
  '12': {
    id: 12,
    name: 'cmmc3',
    path: 'cmmc3',
    humanName: 'CMMC',
    frameworkTitle: 'CMMC Level 3',
    manageFrameworksName: 'CMMC Level 3',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: false,
    parse: false,
    layout: 1,
    levels: true,
    enabled:null
  },
  '13': {
    id: 13,
    name: 'nistcsf',
    path: 'nistcsf',
    humanName: 'NIST CSF',
    frameworkTitle: 'NIST CSF',
    manageFrameworksName: 'NIST CSF',
    color: '#0f3d59',
    fill_color: '#0f3d59',
    description: '',
    flat: false,
    parse: false,
    layout: 2,
    enabled:null
  },
  '15': {
    id: 15,
    name: 'iso90012015',
    path: 'iso90012015',
    humanName: 'ISO 9001:2015',
    frameworkTitle: 'ISO 9001:2015',
    manageFrameworksName: 'ISO 9001:2015',
    color: '#0f3d59',
    fill_color: '#0f3d59',
    description: 'ISO 9001:2015 specifies requirements for a quality management system.',
    flat: false,
    parse: false,
    layout: 1,
    enabled:null
  },
  16: {
    id: 16,
    name: 'nbcu',
    path: 'nbcu',
    humanName: 'NBCU',
    frameworkTitle: 'NBCU',
    manageFrameworksName: 'NBCU',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: true,
    parse: false,
    layout: 1,
    enabled:null
  },
  '18': {
    id: 18,
    name: 'northstarcmm',
    path: 'northstarcmm',
    humanName: 'North Star CMM',
    frameworkTitle: 'North Star CMM',
    manageFrameworksName: 'North Star CMM',
    color: '#ff66ff',
    fill_color: '#ff66ff',
    description: ``,
    flat: false,
    parse: false,
    layout: 1,
    levels: false,
    enabled:null
  },
}



// WEBPACK FOOTER //
// ./src/utils/frameworkMapping.js